import * as BABYLON from "babylonjs";
import BasicComponent from "./BasicComponent";

class VideoSphere extends BasicComponent {
  getType() {
    return "VideoSphere";
  }

  constructor({ id } = {}) {
    super({ id });
    this.context = undefined;
    this.prefab = undefined;
    this.video = undefined;

    this.situationID = undefined;
  }

  async construct(context, prefab) {

    context.setLoadingscreenVisible(1);

    this.prefab = prefab;
    this.context = context;
    this.situationID = context.currentSituationID;

    const base = super.construct(context, prefab).getRootNode();
    const name = "SituationVideo_" + prefab.getSphereVideoID();
    //   const panoramaVideo = MediaManager.getMedia(prefab.getSphereVideoID());

    var videoTag = document.createElement("video");
    this.videoTag = videoTag;
    var replaced = prefab.getName().substring(1); //decodeURIComponent(prefab.getName())//.replace('%20', "")

    videoTag.width = "3840";
    //videoTag.controls = true;
    videoTag.id = "videoShaka";

    shaka.polyfill.installAll();

    window.dispatchEvent(
      new CustomEvent("updateLoadingValue", { detail: { value: "0" + "%" } })
    );

    const player = new shaka.Player(videoTag);
    console.log("Shaka Player supported: " + shaka.Player.isBrowserSupported());

    //  const ui = new shaka.ui.Overlay(player, videoContainer, videoTag);
    //  const controls = ui.getControls();

    this.player = player;
    // Listen for error events.
    // player.addEventListener('error', onErrorEvent);

    var videoContainer = document.getElementById("subtitlesTag"); //document.createElement("div");

    let textTrackDisplayer = new shaka.text.UITextDisplayer(
      videoTag,
      videoContainer
    );
    textTrackDisplayer.setTextVisibility(true);

    let chosenLanguage = context.$store.getters.chosenLanguage;
    let language = chosenLanguage == "de" ? "de-DE" : "en-EN";

    player.configure({
      preferredAudioLanguage: language,
      streaming: {
        bufferingGoal: 10.0,
        rebufferingGoal: 2.0,
        useNativeHlsOnSafari: true,
      },
      textDisplayFactory: () => {
        return textTrackDisplayer;
        /*
        return {
          append: ( cues ) => { cues.map( x => { console.log( x.payload ); } ); },
          setTextVisibility: () => {},
          isTextVisible: () => true,
          destroy: () => { },
          remove: ( startTime, endTime ) =>  { console.log(" Remove - " + startTime + " - " + endTime ); }
            }
            */
      },
    });

    // Try to load a manifest.
    // This is an asynchronous process.
    //const manifestUriDash = '/media/Evonik360/Stations/'+ replaced +"/" + replaced +'_master.mpd';
    const manifestUriHLS =
      "./media/Evonik360/Stations/" +
      replaced +
      "/" +
      replaced +
      "_master.m3u8";

    try {
      await player.load(manifestUriHLS).then(function () {

        player.selectTextTrack(1);
        //player.enableTextTrack( true );
      
      });
      // This runs if the asynchronous load is successful.
    } catch (e) {
      await player.load(manifestUriHLS);
      // onError is executed if the asynchronous load fails.
      onError(e);
    }

    /*
      await player
        .load(manifestUriHLS)
        .then(() => {
          console.log("The video has now been loaded! (UriHLS)");
          var tracks = player.getTextTracks();
          console.log(JSON.stringify(tracks));
          player.selectTextTrack(1);
          player.setTextTrackVisibility(true)
         // player.enableTextTrack( true );
          tracks = player.getTextTracks();
          console.log(JSON.stringify(tracks));
          console.log( JSON.stringify( player.getConfiguration() ) );
        });
        .catch((error) => {
          console.log("Shaka Error " + error);

          
                await player.load(manifestUriHLS).then( () => {
                    console.log('The video has now been loaded! (UriHSL');
                } ).catch( (error) => {
                    console.log("Shaka Error " + error);
                    
                });

        });
      // This runs if the asynchronous load is successful.
    } catch (e) {
      console.log("ERROR: " + e);
      //await player.load(manifestUriHLS);
      // onError is executed if the asynchronous load fails.
      //onError(e);
      
    }

    //  const v = document.getElementById('videoShaka');
    //  console.log(v)
    //  document.dispatchEvent(new CustomEvent("LoadShakaPlayer"));

    //videoTag.src = "/media/Evonik360/Stations/0_1_Uebersicht/0_1_Uebersicht_1920x1080_Fallback.mp4";

    //  videoTag.src = "/media/Evonik360/Stations/"+ replaced +"/" + replaced +"_1920x1080_Fallback.mp4";
*/
    let loopVar = undefined;
    prefab.loop == "true" ? (loopVar = true) : (loopVar = false);

    let autoPlayVar = context.enablePanoramaVideoAutoplay;
   
    if (prefab.autoplay == "false") {
      autoPlayVar = false;
    }

    const myVideoDome = new BABYLON.VideoDome(
      name,
      videoTag,
      {
        resolution: 32,
        clickToPlay: false,
        loop: loopVar,
        autoPlay: autoPlayVar,
        poster: "",
        size: 400,
        faceForward: false,
      },
      window.scene
    );
    myVideoDome.parent = base;

    this.video = videoTag; //myVideoDome.videoTexture.video;

    var cueFunction = (event) => {
      let chosenLanguage = context.$store.getters.chosenLanguage;

      for (let i = 0; i < videoTag.textTracks.length; i++) {
        if (videoTag.textTracks[i].language == chosenLanguage) {
          videoTag.textTracks[i].mode = "showing";
          console.log("Showing " + chosenLanguage + " texttrack");
        } else {
          videoTag.textTracks[i].mode = "disabled";
        }
      }


      for (let i = 0; i < videoTag.textTracks.length; i++) {
        console.log(videoTag.textTracks[i]);
        if (videoTag.textTracks[i].mode == "showing") {
          for (let j = 0; j < videoTag.textTracks[i].activeCues?.length; j++) {
            console.log(videoTag.textTracks[i].activeCues[j].text);
            
            videoContainer.innerHTML =
              videoTag.textTracks[i].activeCues[j].text.replace(/(?:\r\n|\r|\n)/g, '<br>');
            videoContainer.style.padding = "20px";
          }
        }
      }
    };

    this.video.textTracks.onaddtrack = function (e) {
      for (let i = 0; i < videoTag.textTracks.length; i++) {
        videoTag.textTracks[i].addEventListener("cuechange", cueFunction);
      }


    };

    // update runtimestate: update loaded data of video in %
    this.video.onprogress = function () {
      var bf = this.buffered;
      var loadedPercentage =
        bf.length > 0 ? (bf.end(bf.length - 1) / this.duration) * 100 : 0;
      loadedPercentage =
        context.$browserDetect.isFirefox && loadedPercentage > 70
          ? 100
          : loadedPercentage; //Firefox wont trigger progress again when video completely loaded
      context.updateRuntimeState({
        id: prefab.getID(),
        percentageLoaded: loadedPercentage,
      });
    };

    // update runtimestate: change currentTime when the panorama video currenttime changed
    // timeupdate event fires when the panorama video attribute currentTime changed
    this.video.ontimeupdate = () => {
      context.updateRuntimeState({
        id: this.prefab.getID(),
        currentTime: this.video.currentTime,
      });
    };

    // update runtimestate: change duration when the panorama video meta data are loaded (meta data include duration of video)
    let self= this
    this.video.onloadeddata = () => {

      if(self.prefab.autoplay!="true")
        this.pause();
       else
       context.setLoadingscreenVisible(0);

      context.updateRuntimeState({
        id: this.prefab.getID(),
        duration: this.video.duration,
      });

      var tracks = player.getTextTracks();
      for (let i = 0; i < tracks.length; i++) {
        if (tracks[i].language == chosenLanguage) {
          tracks[i].active = true;
          player.selectTextTrack(tracks[i]);
        } else {
          tracks[i].active = false;
        }
      }

      window.dispatchEvent(
        new CustomEvent("updateLoadingValue", {
          detail: { value: "100" + "%" },
        })
      );
      // context.$store.commit("setNewSceneFullyLoaded", true);

      /*
      var tracks = player.getTextTracks();
      console.log(JSON.stringify(tracks));
      player.selectTextTrack(1);
      player.setTextTrackVisibility(true);
*/
      setTimeout(() => {
        // context.setLoadingscreenVisible(-1); //Disable loadingscreen when meta data is loaded to prevent white screen
      }, 500);
    //  console.log("setLoadingscreenVisible(-1)")
   //   context.setLoadingscreenVisible(-1);

      if (videoTag.audioTracks) {
        for (let i = 0; i < videoTag.audioTracks.length; i++) {
          if (videoTag.audioTracks[i].language == chosenLanguage) {
            videoTag.audioTracks[i].enabled = true;
          } else {
            videoTag.audioTracks[i].enabled = false;
          }
        }
      }
      if (videoTag.textTracks) {
        for (let i = 0; i < videoTag.textTracks.length; i++) {
          if (videoTag.textTracks[i].language == chosenLanguage) {
            videoTag.textTracks[i].mode = "showing";
          } else {
            videoTag.textTracks[i].mode = "disabled";
          }
        }
      }
    };

    // update runtimestate: change playstate of video to paused when video ended
    this.video.onended = () => {
      this.pause();
      context.updateRuntimeState({ id: this.prefab.getID(), playing: false });
      window.dispatchEvent(
        new CustomEvent("video_ended", { detail: { id: this.situationID } })
      );
    };
    // update runtimestate: set playing state based on video autoplay
    context.updateRuntimeState({
      id: this.prefab.getID(),
      paused: !context.enablePanoramaVideoAutoplay,
    });

    /** Edge cases **/

    // Chrome shows blackscreen as thumbnail -> happens when video is not autoplayed or browser stops autoplaying
    // quickly play and pause video to get first frame as thumbnail

    if (this.video.paused && context.$browserDetect.isChrome) {
      console.log("VideoSphere: fixing Chrome thumbnail");

      // muted videos can be autoplayed
      // mute and play Video to get thumbnail,
      this.video.muted = true;
      let promise = this.video.play();

      // After play is successful pause and unmute video again
      promise.then(() => {
        this.pause();
        this.video.muted = false;

        // Ensure autoplay after user interaction for chrome
        if (context.enablePanoramaVideoAutoplay) {
         // this.play();
          console.log(
            "VideoSphere: adding function to simulate Autoplay - Chrome"
          );
          window.scene.onPointerDown = () => {
            if (this.situationID == this.context.currentSituationID)
              this.play();
          };
        }
      });
    }

    // if autoplay is enabled and video is paused the browser stopped autoplay -> happens when first situation contains a video and the video is not muted
    // Modern Browsers stop autoplay of videos with sound on when the user didnt interact with the document first
    // Runs when meta data is loaded because safari stops video when metacdata is loaded
    /* TODO: Display an Overlay to force the user to interact with the document first. With that we can get Autoplay with sound on */

    this.video.addEventListener("loadedmetadata", () => {
      if (this.video.paused && context.enablePanoramaVideoAutoplay) {
        console.log("VideoSphere: adding function to simulate Autoplay");
        this.pause(); //Call pause again to update runtimestate
        //this.play();
        window.scene.onPointerDown = () => {
          if (this.situationID == this.context.currentSituationID) this.play();
        };
      }
    });

    window.addEventListener("startVideo", (e) => {
      this.play();
    });
    return base;
  }

  reloadVideo() {
    this.context.setLoadingscreenVisible(1);
    //this.context.setLoadingscreenVisible(1);
    //this.pause();
    window.dispatchEvent(
      new CustomEvent("updateLoadingValue", { detail: { value: "0" + "%" } })
    );
    this.context.setLoadingscreenVisible(1);
    var replaced = this.prefab.getName().substring(1);
    const manifestUriHLS =
      "./media/Evonik360/Stations/" +
      replaced +
      "/" +
      replaced +
      "_master.m3u8";

    try {
      this.player
        .load(manifestUriHLS)
        .then(() => {
          console.log("The video has now been reloaded! (UriHLS)");
        
        })
        .catch((error) => {
          console.log("Shaka Error " + error);
        });
      // This runs if the asynchronous load is successful.
    } catch (e) {
      console.log("Error " + e);
      //await player.load(manifestUriHLS);
      // onError is executed if the asynchronous load fails.
      //onError(e);
    }
  }

  enable() {
    super.enable();

    this.reloadVideo();
    //if (this.context.enablePanoramaVideoAutoplay) this.play();
  }

  disable() {
    console.log("Disable Videosphere");

    this.video.src = "";
    super.disable();
    this.pause();
  }

  pause() {
    super.pause();
    this.video.pause();
    this.context.updateRuntimeState({
      id: this.prefab.getID(),
      paused: this.video.paused,
    });
  }

  play() {
    super.play();
    this.video.play();
    this.context.updateRuntimeState({
      id: this.prefab.getID(),
      paused: this.video.paused,
    });

    // Remove onPointerDown when user plays video
    if (window.scene.onPointerDown) window.scene.onPointerDown = undefined;
  }

  jumpToTimePosition(time) {
    super.jumpToTimePosition(time);
    this.video.currentTime = time;
    this.context.updateRuntimeState({
      id: this.prefab.getID(),
      currentTime: time,
    });
  }

  changeVolume(volume) {
    super.changeVolume(volume);
    this.video.volume = volume;
    this.video.muted = volume == 0;
    this.context.updateRuntimeState({
      id: this.prefab.getID(),
      volume: volume,
    });
  }

  update() {}
}

export default VideoSphere;
